import React from 'react';
import { Icon } from '@iconify/react';
import Image from 'next/image';
import Link from 'next/link';

/**
 * SectionNavbar Component
 * Navigation bar with top social bar and main navigation
 */
const SectionNavbar: React.FC = () => {
  const logoUrl = "/image/logo.webp";

  return (
    <div  className="bg-black md:h-[67px] h-full flex items-center justify-center lg:px-[60px] md:px-[60px] px-[24px] md:py-0 py-4">
      <div className="flex gap-6 items-center justify-between w-full max-w-6xl mx-auto">
        {/* Logo */}
        <Image
          width={100}
          height={100}
          src={logoUrl}
          alt="Pekalen Rafting Probolinggo"
          className="md:h-[36.17px] md:w-[186.8px] h-[24px] w-[123.8px] cursor-pointer"
        />

        {/* Navigation Menu */}
        <div className="flex gap-3 items-center text-white font-family-open-sans">
              <Icon icon="flowbite:facebook-solid" fontSize={18} className="cursor-pointer" />
              <Icon icon="bi:twitter-x" fontSize={18} className="cursor-pointer" />
              <Icon icon="bi:instagram" fontSize={18} className="cursor-pointer" />
              <Link href="https://admin.pekalenrafting.co.id/">
                  <div className='text-white border border-white rounded-full py-2 px-4 text-[12px] font-semibold'>
                    <p>Login</p>
                  </div>
              </Link>
          </div>
      </div>
    </div>
  );
};

export default SectionNavbar;
